import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { useAuthState } from '@creditornot/wolt-auth/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import ScientistError from 'common/illustrations/ScientistError';
import { Typography as T } from 'common/typography';

const Root = styled.div`
  margin: 0 auto;
  height: 100%;
  max-width: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  text-align: center;
`;

const Header = styled(T.Heading4)`
  margin-block-end: 8px;
  margin-block-start: 32px;
`;

const Description = styled(T.Body2)`
  display: block;
  color: ${cbSemanticCssVars.textSecondary};
  margin: 12px 0 32px;
`;

const StyledScientistError = styled(ScientistError)`
  width: 100%;
  max-width: 500px;
`;

const LinkExpiredPage = () => {
  const { user } = useAuthState();
  const { pathname } = useLocation();

  return (
    <Root>
      <Container>
        <StyledScientistError />

        <Header>
          <FormattedMessage id="photo-shoot.link-expired.header" />
        </Header>

        <Description>
          <FormattedMessage id="photo-shoot.link-expired.paragraph1" />
          &nbsp;
          <FormattedMessage id="photo-shoot.link-expired.paragraph2" />
        </Description>

        {!user && (
          <Link to={{ pathname: '/login', search: `?next=${pathname}` }}>
            <Button size="small" variant="secondary">
              <FormattedMessage id="photo-shoot.link-expired.log-in" />
            </Button>
          </Link>
        )}
      </Container>
    </Root>
  );
};

export default LinkExpiredPage;
